  
<!--降雨实况-->
<template>
    <div class="rainSk">
        <div class="control">
            <el-select v-model="selectTime" value-key="label"  style="width:130px;" class="time">
              <el-option 
                v-for="item in optionTime" 
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
              <el-date-picker
                v-show="selectTime==5"
                  v-model="times[0]"
                  value-format="yyyy-MM-dd HH:00" format="yyyy-MM-dd HH:00" 
                  size="medium"
                  type="datetime"
                  style="width:180px; "
                  placeholder="开始时间">
              </el-date-picker>
              <el-date-picker
                  v-show="selectTime==5"
                  v-model="times[1]"
                  size="medium"
                  style="width:180px;"
                  value-format="yyyy-MM-dd HH:00" format="yyyy-MM-dd HH:00" 
                  type="datetime"
                  placeholder="结束时间">
              </el-date-picker>
              <el-cascader
              :options="areaOptions"
              :props='defaultProps'
              v-model="area"
              placeholder="请选择区域"
              change-on-select
              style="width: 110px;"
            ></el-cascader>
            <el-button type="primary" @click="rainFall" icon="el-icon-search" ></el-button>
            <!-- <el-button type="primary" @click="excelRain" >导出</el-button> -->
            
        </div>
        <h3>降雨实况表</h3>
        <el-table
        :data="rainFallData"
        style="width: 100%"
        :height="height-10"
        class="rainFallTable">
        <el-table-column type="index"  align="center"> </el-table-column>
        <el-table-column prop="STNM" label="站名" align="center"> </el-table-column>
        <el-table-column prop="SUM_INTV" label="累计降雨(mm)" align="center"> </el-table-column>
        <el-table-column prop="RGNNM" label="所在政区" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="HNNM" label="水系"  align="center" width="100"> </el-table-column>
        <el-table-column prop="RVNM" label="河流名字"  align="center" width="140"> </el-table-column>
        <el-table-column prop="STLC" label="站址" align="center" show-overflow-tooltip></el-table-column> -->
      </el-table>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="currentTotal">
      </el-pagination> -->
    </div>
</template>
<script>
import $ from "jquery";
let moment = require("moment");
const alladcd = require('./hnqx.json')
export default {
  name: "rainfb",
  data() {
    return {
      height:0,
      width:0,
      rainFallData:[],
      areaOptions: alladcd,
      defaultProps: {
        children: 'children',
        label: 'adnm',
        value:'adcd'
      },
      area:['430000'],
      adcd2:window.HTCFG.adcd,
      times:this.datevalue2(),
      currentPage: 1,
      pageSize: 20,
      currentTotal: 0,
      options:window.HTCFG.AD,
      selectTime:this.datevalue(),
      optionTime:[
        {
          value:1,
          label:'今天8点到现在'
        },
        {
          value:2,
          label:'昨天8点到现在'
        },
        {
          value:3,
          label:'最近24小时'
        },
        {
          value:4,
          label:'最近48小时'
        },
        {
          value:5,
          label:'自定义'
        }
      ],
    };
  },
  watch:{
    'selectTime': function(){
      if(this.selectTime=="1"){
        this.times=[
          moment().format("YYYY-MM-DD 08:00"),
          moment().format("YYYY-MM-DD HH:mm")
        ]
      }else if(this.selectTime=="2"){
        this.times=[
          moment().add(-1,'days').format("YYYY-MM-DD 08:00"),
          moment().format("YYYY-MM-DD HH:mm")
        ]
      }else if(this.selectTime=="3"){
        this.times=[
          moment().add(-1,'days').format("YYYY-MM-DD HH:mm"),
          moment().format("YYYY-MM-DD HH:mm")
        ]
      }else if(this.selectTime=="4"){
        this.times=[
          moment().add(-2,'days').format("YYYY-MM-DD HH:mm"),
          moment().format("YYYY-MM-DD HH:mm")
        ]
      }
    },
  },  
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
    },
    datevalue(){
      if(new Date().getHours()<9){
        return 2
      }else{
        return 1
      }
    },
    datevalue2(){
      if(new Date().getHours()<9){
        return [moment(new Date()).add(-1,'days').format("YYYY-MM-DD 08:00"),
            moment(new Date()).format("YYYY-MM-DD HH:mm")]
      }else{
        return [
              moment(new Date()).format("YYYY-MM-DD 08:00"),
              moment(new Date()).format("YYYY-MM-DD HH:mm")
        ]
      }
    },
    //自定义滚动
    setColgroup(){
      let thatVue=this;
      setTimeout(function() {
        $(".rainFallTable").find("[name='gutter'],.gutter").remove();
        let tempTable=$(".rainFallTable").find("table");
        tempTable.eq(0).width("100%");
        tempTable.eq(1).width("100%");  
        let scrollbar=$(".rainFallTable").find(".el-table__body-wrapper");
        let scrollbarH=scrollbar.parent().height()-45;
        scrollbar.height(scrollbarH).niceScroll({
                cursorcolor: "#3380f3", // 改变滚动条颜色，使用16进制颜色值
                cursorwidth: "5px", // 滚动条的宽度，单位：便素
                cursorborderradius: "5px", // 滚动条圆角（像素）
                cursorborder: "1px solid rgba(144,147,153,.65)", // CSS方式定义滚动条边框
                background: "rgba(144,147,153,.5)", //轨道背景
                autohidemode: "leave",
                hidecursordelay: 400, // 设置滚动条淡出的延迟时间（毫秒）
                nativeparentscrolling: true, // 检测内容底部便于让父级滚动
                smoothscroll: true, // ease动画滚动
                sensitiverail: true, // 单击轨道产生滚动
                railpadding: { top: 0, right: 1, left: 1, bottom: 0 }, // 设置轨道的内间距
                horizrailenabled:false//水平滚动
           });      
      }, 500); 
    },
    //去除政区编码尾部的0--1
    del0(str){
      str=str+"";
      if(str==""){
        return str;
      }
      let temp=str;
      for(let len=str.length,i=len-1;i>=0;i--){
        if(str.slice(i)-0!=0){
          temp=str.slice(0,i+1);
          break;
        }
      }
      if(temp == "431"){
        temp = "4310";
      }
      return temp;
    },
    async rainFall(){
      this.rainFallData=[];
      this.adcd2=this.del0(this.area[this.area.length-1]);
      this.$http.get(window.HTCFG.apiUrl+"api/core/rain/queryRain/"+this.adcd2+'/'+moment(this.times[0]).valueOf()+'/'+moment(this.times[1]).add(1,'hour').valueOf()).then(res => {
          let result = JSON.parse(res.body.substring(res.body.indexOf("{"),res.body.lastIndexOf("}")+1));
          console.log(result.Data)
          this.rainFallData=result.Data;
          this.currentTotal=result.Data.length;
          // this.setColgroup();
      })
    },
    excelRain(){
      this.$http.get(window.HTCFG.apiUrl+"api/core/excelRain/"+this.adcd2+'/'+moment(this.times[0]).valueOf()+'/'+moment(this.times[1]).add(1,'hour').valueOf()).then(res => {
        // console.log(res);
        window.location.href = res.url;
      
      })
    }
  },
  mounted() {
    // $(".rainSk").height(window.innerHeight-140-35-20);
      $(".rainSk").height(window.innerHeight-100);
    var w=$(".rainSk").width();
    this.height=$(".rainSk").height()-2;
    this.width=w;
    this.rainFall()
  }
};
</script>
<style scoped lang='less'>
  .rainSk{
    width:100%;
    .control{
      margin-bottom: 10px;
    }
    h3{
      line-height: 40px;
      text-align: center;
      font-size: 26px
    }  
  }
</style>
 


// WEBPACK FOOTER //
// src/components/mobile/rainSk.vue